import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "./../styles/AboutUs.css";
import About1 from "../Logos To be used/About1.webp";
import About2 from "../Logos To be used/About2.webp";
import About3 from "../Logos To be used/About3.webp";

const AboutUs = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: About2,
      text: [
        "Die schwierigsten Universitätsfächer mit klaren,",
        "strukturierten Ressourcen vereinfachen.",
      ],
    },
    {
      image: About3,
      text: [
        "Ermöglichen, mit adaptiven Werkzeugen",
        "in deinem eigenen Tempo voranzukommen.",
      ],
    },
  ];

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  }, [slides.length]);

  const prevSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  }, [slides.length]);

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(interval);
  }, [nextSlide]);

  return (
    <div className="about-page">
      <section className="about-hero">
        <img src={About1} alt="About Us" className="about-hero-image" />
        <div className="about-hero-overlay" />
        <div className="about-hero-content">
          <p className="about-eyebrow">A Legacy of Learning</p>
          <blockquote className="about-quote">
            <p>
              “It is not what is poured into a student that counts, but what is
              planted.”
            </p>
            <cite>Linda Conway</cite>
          </blockquote>
        </div>
      </section>

      <section className="about-section about-section-intro">
        <div className="about-intro-grid">
          <div className="about-intro-copy">
            <p className="about-section-kicker">Unsere Mission</p>
            <h2>Lernen leicht gemacht</h2>
            <p className="about-description">
              Jeder Student verdient die Chance, erfolgreich zu sein, unabhängig
              von den Hindernissen, denen er gegenübersteht. Wir haben diese
              Plattform geschaffen, um die Frustrationen und Hürden anzugehen,
              die mit der Bewältigung schwieriger Universitätsfächer einhergehen,
              und bieten Werkzeuge und Ressourcen, die das Lernen einfacher und
              wirklich angenehm machen.
            </p>
          </div>

          <aside className="about-intro-aside">
            <div className="about-feature-card">
              <p>Kuratiert</p>
              <h3>Strukturierte Lernpfade</h3>
              <span>Von komplex zu verständlich.</span>
            </div>
            <div className="about-feature-card about-feature-card-accent">
              <p>Fokus</p>
              <h3>Praxisnahe Prüfungsvorbereitung</h3>
              <span>Konsequent auf akademischen Erfolg ausgerichtet.</span>
            </div>
          </aside>
        </div>
      </section>

      <section className="about-section about-section-slider">
        <div className="about-slider-head">
          <div>
            <p className="about-section-kicker">Our Narrative</p>
            <h2>Evolution of Knowledge</h2>
          </div>
          <div className="slider-controls">
            <button
              className="arrow left-arrow"
              onClick={prevSlide}
              type="button"
              aria-label="Vorheriger Slide"
            >
              &#8249;
            </button>
            <button
              className="arrow right-arrow"
              onClick={nextSlide}
              type="button"
              aria-label="Nächster Slide"
            >
              &#8250;
            </button>
          </div>
        </div>

        <div className="slider-container">
          <div
            className="slider"
            style={{
              transform: `translateX(-${currentSlide * 100}%)`,
            }}
          >
            {slides.map((slide, index) => (
              <article className="slide" key={index}>
                <img
                  src={slide.image}
                  alt={`Slide ${index + 1}`}
                  className="slide-image"
                />
                <div className="slide-overlay" />
                <div className="slide-text">
                  {slide.text.map((line, i) => (
                    <p key={i} className="slide-line">
                      {line}
                    </p>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="about-section about-section-second">
        <div className="about-second-layout">
          <div className="about-second-title">
            <span className="about-accent-line" />
            <h2>Schwierige Fächer mit Zuversicht angehen</h2>
          </div>
          <div className="about-second-content">
            <p className="about-description">
              Schwierige Fächer zu meistern erfordert mehr als nur Anstrengung –
              es braucht den richtigen Ansatz. Unsere Plattform stellt sicher,
              dass du komplexe Themen vollständig verstehst und gleichzeitig
              praktische Erfahrungen mit echten Prüfungsfragen sammeln. Durch die
              Kombination von Lernen und praktischer Anwendung bereiten wir dich
              auf deinen akademischen Erfolg vor.
            </p>
            <div className="about-second-note">
              <h3>Akademisch fundiert. Verständlich aufbereitet.</h3>
              <p>
                LearnHut verbindet Klarheit in der Vermittlung mit der Tiefe
                universitärer Inhalte.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-cta">
        <div className="about-cta-content">
          <h2>Bereit, deine akademische Reise zu transformieren?</h2>
          <p>
            Starte direkt im Dashboard und entdecke kuratierte
            Lernpfade für anspruchsvolle Fächer.
          </p>
          <button
            className="explore-button"
            type="button"
            onClick={() => navigate("/dashboard")}
          >
            Kurse erkunden
          </button>
        </div>
      </section>

      <div className="about-footer-spacing" />
    </div>
  );
};

export default AboutUs;
